import { useContext } from 'react';
import { SurveyListFilterContext } from '../context';

export function useSurveyListFilter() {
	return useContext(SurveyListFilterContext);
}
